export const state = () => ({
  widget: {
    Series: [],
    Settings: {},
    BusinessRuleDataTable: null
  },
  businessRules: [],
  kpis: [],
  businessRuleColumn: [],
  openSeriesPanel: 0,
  seriesSpecificFields: [],
  widgetConfigFormValid: false,
  previousWidget: null,
  openColorPanel: null,
  cancelWidget: false,
  dashboardWidgets: [],
  businessRuleFieldsMap: {},
  fieldsLoaded: false,
  kpisLoaded: false,
  seriesRenderKey: 1,
  widgetWidth: null,
  currentProcessFlowNode: {},
  invalidAdvancedSettings: false,
  primaryKey: null,
  dataModelUuid: null
});
